/**
 * Confetti Animation Function
 * Handles the confetti celebration animation when projects are completed
 */

// Function to trigger confetti
function triggerConfetti() {
	var confettiSettings = { target: 'confettiCanvas' };
	var confetti = new ConfettiGenerator(confettiSettings);
	confetti.render();

	// Auto-destroy the confetti after 5 seconds
	setTimeout(() => {
		confetti.clear();
	}, 5000);
}
